import { IComponentOptions } from "angular";
import { MachineConfigurationTypeInfoGamesComponentController } from "./controller";

export const vsComponentName = "machineConfigurationTypeInfoGamesComponent";

export const machineConfigurationTypeInfoGamesComponentOptions: IComponentOptions =
  {
    controller: MachineConfigurationTypeInfoGamesComponentController,
    controllerAs: "gamesController",
    template: require("!html-loader!./index.html").default,
    bindings: {
      games: "<",
      machineConfigurationType: "<",
    },
  };
